import clsx from 'clsx';
import React from 'react';
import Button from '../../basic/button';
import QuickLink from '../../basic/quickLink';
import { Card, CardHeader, CardContent, CardActions } from '../card';
import { Banner } from '../banner';
import { MarketingContentProps } from './IMarketingGrid';
import { DataAnalyticsLocations, DataAnalyticsTypes, buildAnalytics } from '../../basic/analytics';

const MarketingContent = ({
  banner,
  parentAnalyticsLocation,
}: MarketingContentProps): JSX.Element => {
  const card = banner?.card;
  const buttonDataAnalytics = buildAnalytics(
    DataAnalyticsLocations.Card,
    DataAnalyticsTypes.Button,
    [parentAnalyticsLocation, DataAnalyticsLocations.Banner],
  );
  return (
    <Banner
      className={`mb-lg xl:mb-xl lg:flex-row`}
      media={banner.src}
      layout={banner.layout}
      cardLayout={card?.tileLayout}
      cardStyle="lg:absolute lg:self-center"
      enableMobileStack={true}
      data-testid="marketing-content"
      mediaStyle={`${
        banner.layout === 'left-facing'
          ? 'rounded-t-md  xl:rounded-tl-none xl:rounded-tr-md xl:rounded-br-md'
          : banner.layout === 'right-facing'
            ? 'rounded-t-md  xl:rounded-tr-none xl:rounded-tl-md xl:rounded-bl-md'
            : ''
      }
      lg:w-8/12 xl:w-8/12 aspect-w-16 aspect-h-12 sm:aspect-w-16 sm:aspect-h-9 lg:aspect-w-16 lg:aspect-h-6 `}
      alt={banner?.src}
    >
      {card && (
        <Card
          theme={card.theme}
          className={clsx(
            'bg-card-fill flex-col bg-secondary-500 rounded-t-none space-y-md w-full px-md justify-center lg:w-4/12 lg:px-lg lg:max-h-[350px] xl:min-h-[430px] xl:px-xl xl:w-4/12 xl:rounded-md',
            {
              'lg:ml-2xl xl:ml-2xl': card.tileLayout === 'left-facing',
              'lg:mr-2xl xl:mr-2xl': card.tileLayout === 'right-facing',
            },
          )}
        >
          <CardHeader header={card.header} className='lg:text-3xl xl:text-4xl text-3xl'/>
          <CardContent description={card.description} className='lg:h-14'/>
          <CardActions className="flex-row space-x-sm">
            {card?.navigation &&
              card?.navigation.map((btn: any, idx: number) => {
                return (
                    <Button
                      shape="rounded"
                      link={btn.url}
                      key={idx}
                      border={true}
                      dataAnalytics={buttonDataAnalytics}
                    //  aria-hidden={false}
                      aClass="inline-block"
                      className="py-[12px] px-[24px] text-navBlue text-sm font-medium bg-btn-fill border-btn-border bg-color-[#F2F8FB] hover:bg-btn-hover hover:text-btn-hover-text"
                    >
                      {btn.title}
                    </Button>
                );
              })}
          </CardActions>
        </Card>
      )}
    </Banner>
  );
};

export default MarketingContent;
